export default ['milestone', 'action', 'comment', 'water'] as string[]

export const logCategoryDefaults = {
  water: {
    type: 'normal',
  },
  comment: {
    type: 'n/a',
  },
}
